import '../../vendor/jquery-select.js';

export default function() {
    /**
     *
     * @Usage:       $.fn.customSelectOverlay()
     *
     */

    (function( $ ) {
        $.fn.customSelectOverlay = function() {
            let  scrollFocusOnElement = function($wrapper, $el) {
                if ($el.length) {
                    let top = $wrapper.offset().top;
                    let bot = $wrapper.offset().top + $wrapper.outerHeight();
                    let elTop = $el.offset().top;
                    let elBot = $el.offset().top + $el.outerHeight();
                    if (elTop < top) {
                        $wrapper.scrollTop(elTop - top + $wrapper.scrollTop());
                    } else if (elBot > bot) {
                        $wrapper.scrollTop(elBot - $wrapper.outerHeight() - top + $wrapper.scrollTop());
                    }
                }
            };

            let tryDisplayNotFound = function($listWrapper) {
                if (!$listWrapper.children('.custom-option:not(.hide)').length) {
                    $listWrapper.find('.not-found').removeClass('hide');
                } else {
                    $listWrapper.find('.not-found').addClass('hide');
                }
            };

            let markSelected = function($select) {
                let $holder = $select.parent('.j-select-holder');
                let $customOption = $holder.find('.j-custom-option-list');
                $customOption.find('.custom-option:not(.not-found)').each(function (index, item) {
                    if ($(item).attr('value') == $select.val()) {
                        $(item).addClass('is-selected');
                        $(item).addClass('is-focused');
                    } else {
                        $(item).removeClass('is-selected');
                        $(item).removeClass('is-focused');
                    }
                });
            };

            let updateOptionList = function($select, $listWrapper) {
                $listWrapper.children().remove();
                let $option = $('<div class="custom-option"></div>');
                $select.find('option').each(function (index, item) {
                    let $item = $(item);
                    let $clone = $option.clone();
                    $clone.text($item.text());
                    $.each(item.attributes, function(idx, attr) {
                        $clone.attr(attr.name, attr.value);
                    });
                    $listWrapper.append($clone);
                    $clone.on('click', function() {
                        selectOption($select, $clone, $listWrapper);
                    });
                    $clone.on('mouseenter', function() {
                        $listWrapper.find('.custom-option.is-focused').removeClass('is-focused');
                        $clone.addClass('is-focused');
                    });
                });
                $listWrapper.append('<div class="custom-option not-found hide">Not Found</div>');
                tryDisplayNotFound($listWrapper);
            };

            let selectOption = function($select, $option, $listWrapper) {
                let $customOption = $select.parent('.j-select-holder').find('.j-custom-option-list');
                $customOption.addClass('hide');
                enableSelectPointerEvents($customOption);
                $select.val($option.attr('value'));
                $select.change();
            };

            let search = function(term, $listWrapper) {
                if (term) {
                    $listWrapper.find('.custom-option').addClass('hide');
                    $listWrapper.find('.custom-option').each(function (index, item) {
                        if ($(item).text().toLowerCase().includes(term)) {
                            $(item).removeClass('hide');
                        }
                    });
                } else {
                    $listWrapper.find('.custom-option').removeClass('hide');
                }
                let $selected = $listWrapper.find('.custom-option.is-selected:not(.not-found):not(.hide)');
                if ($selected.length) {
                    scrollFocusOnElement($listWrapper, $selected);
                } else {
                    let $focused = $listWrapper.find('.custom-option.is-focused:not(.not-found):not(.hide)');
                    if (!$focused.length) {
                        $focused = $($listWrapper.find('.custom-option:not(.not-found):not(.hide)')[0]);
                    }
                    $listWrapper.find('.custom-option.is-focused').removeClass('is-focused');
                    $focused.addClass('is-focused');
                    scrollFocusOnElement($listWrapper, $focused);
                }
                tryDisplayNotFound($listWrapper);
            };

            let toggleDropdown = function(e, $select) {
                e.preventDefault();
                let $holder = $select.parent('.j-select-holder');
                let $customOption = $holder.find('.j-custom-option-list');
                let $searchInput = $customOption.find('.custom-option-list-search');
                if ($customOption.hasClass('hide')) {
                    resizeDropdown($customOption);
                    $searchInput.val('');
                    $searchInput.trigger('keyup');
                    $customOption.removeClass('hide');
                    $searchInput.focus();

                    $customOption.find('.custom-option.is-focused').removeClass('is-focused');
                    let $selected = $customOption.find('.custom-option.is-selected');
                    $selected.addClass('is-focused');
                    if ($selected.length) {
                        let $listWrapper = $customOption.find('.custom-option-wrapper');
                        let pos = $selected.offset().top - $listWrapper.offset().top + $listWrapper.scrollTop();
                        $listWrapper.scrollTop(pos);
                    }
                    disableSelectPointerEvents($customOption);
                } else {
                    $customOption.addClass('hide');
                    enableSelectPointerEvents($customOption);
                }
            };

            let resizeDropdown = function($select) {
                let $customWrapper = $select.find('.custom-option-wrapper');
                if ($select.css('position') === 'fixed') {
                    $select.css({
                        top: $('.header').outerHeight(),
                        height: 'calc(100% - ' + $('.header').outerHeight() + 'px)'
                    });
                    $customWrapper.css('max-height', 'calc(100% - 62px)');
                    $('body').addClass('no-scroll');
                } else {
                    $select.css({
                        top: 'auto',
                        height: 'auto'
                    });
                    $customWrapper.css('max-height', '200px');
                    $('body').removeClass('no-scroll');
                }
            };

            let enableSelectPointerEvents = function($select) {
                let $holder = $select.parent();
                $holder.closest('form').find('.j-select-holder').not($holder).css({
                    'pointer-events': 'auto'
                });
            };

            let disableSelectPointerEvents = function($select) {
                let $holder = $select.parent();
                $holder.closest('form').find('.j-select-holder').not($holder).css({
                    'pointer-events': 'none'
                });
            };

            $(this).each(function(index, item) {
                let $this = $(item);
                $this.selectOverlap();
                let $customOption = $('<div class="j-custom-option-list custom-option-list hide"></div>');
                let baseClassName = $this.attr('name');
                let cssClass = 'custom-option-list-' + baseClassName;
                let jsClass = 'j-' + cssClass;
                $customOption.addClass(cssClass);
                $customOption.addClass(jsClass);

                let $closeBtn = $('<button type="button" class="hyperlink j-close-custom-select icon-close"></button>');
                $closeBtn.on('click', function() {
                    $('body').removeClass('no-scroll');
                    $customOption.addClass('hide');
                    enableSelectPointerEvents($this);
                });
                $customOption.append($closeBtn);

                let $searchInput = $('<input type="text" class="custom-option-list-search" placeholder="Search">');
                $customOption.append($searchInput);
                

                let $optionList = $('<div class="custom-option-wrapper"></div>');
                $customOption.append($optionList);
                updateOptionList($this, $optionList);

                let $selectOverlay = $($this.parents('.j-select-holder')[0]);
                $selectOverlay.append($customOption);

                $searchInput.on('keyup', function(e) {
                    if (e.which == 38 || e.which == 40 || e.which == 9) {
                        return;
                    }
                    search($searchInput.val().trim().toLowerCase(), $optionList);
                });
                
                $this.on('customSelect:updateOptionList', function(){
                    updateOptionList($this, $optionList);
                });

                $this.on('mousedown', function(e) {
                    toggleDropdown(e, $this);
                });

                $this.on('change', function() {
                    markSelected($this);
                });
                
                $this.closest('form').on('keydown', function(e) {
                    let $target = $(e.target);
                    if ($selectOverlay.has($target).length && (e.which == 32 || e.which == 38 || e.which == 40) && $customOption.hasClass('hide')) {
                        e.preventDefault();
                        $this.trigger('mousedown');
                    }
                });

                $searchInput.on('keydown', function(e) {
                    let $focused = $customOption.find('.custom-option.is-focused:not(.not-found):not(.hide)');
                    let $target;
                    if ($focused.length) {
                        if (e.which == 38) { // key up
                            $target = $($focused.prevAll('.custom-option:not(.hide)')[0]);
                            if (!$target.length) {
                                let $available = $customOption.find('.custom-option:not(.not-found):not(.hide)');
                                $target = $($available[$available.length-1]);
                            }
                            if ($target.length) {
                                $customOption.find('.custom-option.is-focused').removeClass('is-focused');
                                $target.addClass('is-focused');
                                scrollFocusOnElement($optionList, $target);
                            }
                        }
                        
                        if (e.which == 9) {
                            e.preventDefault();
                        }
                        if (e.which == 40 || e.which == 9) { // key down or tab
                            $target = $($focused.nextAll('.custom-option:not(.hide)')[0]);
                            if (!$target.length) {
                                $target = $($customOption.find('.custom-option:not(.not-found):not(.hide)')[0]);
                            }
                            if ($target.length) {
                                $customOption.find('.custom-option.is-focused').removeClass('is-focused');
                                $target.addClass('is-focused');
                                scrollFocusOnElement($optionList, $target);
                            }
                        }
        
                        if (e.which == 13) { // enter
                            e.preventDefault();
                            $focused.click();
                        }
                    } else {
                        if (e.which == 38 || e.which == 40 || e.which == 9) {
                            $target = $($customOption.find('.custom-option:not(.not-found):not(.hide)')[0]);
                            if ($target.length) {
                                $target.addClass('is-focused');
                                scrollFocusOnElement($optionList, $target);
                            }
                        }


                        if (e.which == 13) { // enter
                            e.preventDefault();
                        }
                    }


                    if (e.which == 27) { // esc
                        $customOption.addClass('hide');
                        enableSelectPointerEvents($this);
                    }
                });

                $(document).on('click', function(e) {
                    let $target = $(e.target);
                    if (!$customOption.hasClass('hide')) {
                        if ($customOption.css('position') === 'fixed') {
                            if ($('.header').has($target).length) {
                                $('body').removeClass('no-scroll');
                                $customOption.addClass('hide');
                                enableSelectPointerEvents($this);
                            }
                        }
                        else if (!$selectOverlay.has($target).length) {
                            $customOption.addClass('hide');
                            enableSelectPointerEvents($this);
                        }
                    }
                });

                $(window).resize(function() {
                    if (!$customOption.hasClass('hide')) {
                        resizeDropdown($customOption);
                    }
                });

                markSelected($this);
            });
        };
    })(jQuery);
}
